<template>
  <div class="app-container">
    <!-- 信息栏 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>基本信息</span>
        <i :class="isOpen? 'el-icon-caret-top' :'el-icon-caret-bottom'" style="float:right; cursor: pointer;" @click="isOpen = !isOpen"></i>
      </div>
      <div class="info-box" v-if="isOpen">
        <div class="item">
          <span>项目ID：</span>
          <span>{{infoData.projectId}}</span>
        </div>
        <div class="item">
          <span></span>
          <span>
            <el-tooltip effect="dark" content="上传更新Project配置" placement="top">
              <el-button icon="el-icon-refresh" size="mini" type="primary" :loading="shuaxinloading" @click="shuaxinbtn">刷新</el-button>
            </el-tooltip>
          </span>
        </div>
        <div class="item">
          <span></span>
          <span>
            <el-tooltip class="dark" effect="dark" content="配置执行参数" placement="top">
              <el-button icon="el-icon-s-promotion" size="mini" type="success" @click="zhixingbtn">执行</el-button>
            </el-tooltip>
          </span>
        </div>
        <div class="item">
          <span>flowId：</span>
          <span>{{infoData.flowId}}</span>
        </div>
        <div class="item">
          <span>flowName：</span>
          <span>{{infoData.flowName}}</span>
        </div>

        <div class="item">
          <span>调度模式：</span>
          <span>{{infoData.scheduleMode}}</span>
        </div>
        <div class="item">
          <span>调度规则：</span>
          <span>{{infoData.crontabRule}}</span>
        </div>
        <div class="item">
          <span>监控状态：</span>
          <el-switch v-model="infoData.isMonitor" size="mini" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
        </div>
        <div class="item">
          <span>flow状态：</span>
          <span>{{infoData.flowState | updateTypeFilter}}</span>
          <!-- <i v-if="infoData.updateType == 0" class="el-icon-refresh" style="margin: 0 5px; color:#F56C6C; cursor: pointer;"></i> -->
        </div>
        <div class="item" style="width:100%">
          <span>Appkes：</span>
          <span style="word-break:normal; width:auto; display:block;white-space:pre-wrap;word-wrap : break-word ;overflow: hidden ;">{{infoData.appkeys}}</span>
        </div>

      </div>
    </el-card>

    <el-card class="box-card" style="margin-top:10px">
      <div slot="header" class="clearfix">
        <span>定时任务</span>
        <!-- 搜索 -->
        <el-input placeholder="请输入内容" size="small" v-model="search1" clearable style="width:200px; margin-left: 50px"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>

        <div style="float:right; display:flex;margin-top:5px;margin-left:15px">
          <i :class="isRelaOpentable? 'el-icon-caret-top' :'el-icon-caret-bottom'" style=" cursor: pointer;" @click="isRelaOpentable = !isRelaOpentable"></i>
        </div>
        <div class="filterTableHeader" style="float:right;">
          <el-popover width="400" trigger="click">
            <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
            <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle1">
              <el-checkbox v-for="(item,index) in tableTheadOptions1" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
            </el-checkbox-group>
          </el-popover>
        </div>

      </div>

      <el-table v-if="isRelaOpentable" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" size='mini' border v-loading="listLoading" :data="tableList1" style="width: 100%;" stripe>
        <el-table-column v-for="(item,index) in tableTheads1" :key="index" :label="item[Object.keys(item)[0]]" min-width="130px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="Object.keys(item)[0] == 'executionOptions'" @click="jinruyouxi(scope.row.executionOptions)" style="color:#646cf5;cursor: pointer;">{{ scope.row.executionOptions | neirongsuojian}}</span>
            <span> {{ scope.row[Object.keys(item)[0]]}}</span>
          </template>

        </el-table-column>

        <el-table-column label="操作" width="80px" class-name="small-padding fixed-width" fixed="right">
          <template slot-scope="scope">
            <el-popconfirm title="确定删除此条信息？" @onConfirm="handleDelete(scope.row)">
              <el-button slot="reference" size="mini" style="padding: 4px 15px;" type="danger">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 关系信息 -->
    <el-card class="box-card" style="margin-top:10px">
      <div slot="header" class="clearfix">
        <span>关系图</span>
        <div style="float:right; display:flex;">
          <i :class="isRelaOpen? 'el-icon-caret-top' :'el-icon-caret-bottom'" style=" cursor: pointer;" @click="isRelaOpen = !isRelaOpen"></i>
        </div>
      </div>
      <div class="info-box" v-if="isRelaOpen" id="graph-box" style="height: 480px;">

        <!-- 图示 -->
        <dagre ref="dagre" :graphData="graphData" @getnodetitle="getnodetitle"></dagre>
      </div>
    </el-card>

    <el-dialog title="执行信息" :visible.sync="dialogFormzhixing" :close-on-click-modal="false" append-to-body width="600px" top="10vh">

      <el-form label-position="right" label-width="80px">
        <el-form-item label="Cron">
          <input-cron size="mini" v-model="cron" :hide-year="false"></input-cron>
        </el-form-item>

        <el-form-item label="Address">
          <el-select class="select-box" :popper-append-to-body="false" size="mini" v-model="address" multiple collapse-tags filterable clearable placeholder="请选择"  style="width:230px;" >
            <el-option v-for="(item,index) in addressOptions" :key="index" :value="item.name">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.ip }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="拓展参数">
          <div v-for="(list,index) in paramslist" :key="index">
            <el-input v-model="list.label" style="width:40%;float:left" size="mini" placeholder="参数名"></el-input>
            <el-input v-model="list.value" style="width:40%;float:left;margin-left:5px" size="mini" placeholder="参数值"></el-input>
            <i class="el-icon-circle-plus-outline" style="color:rgb(19, 206, 102);font-size:24px;cursor:pointer;float:left;margin-top:5px;margin-left:5px" @click="addcanshu"></i>
            <i class="el-icon-circle-close" v-if="paramslist.length>1" style="color:#ff4500;font-size:24px;cursor:pointer;float:left;margin-top:5px;margin-left:5px" @click="deletecanshu($event,index)"></i>
          </div>
        </el-form-item>
      </el-form>

      <!-- 按钮组 -->
      <div class="butn-box" style="text-align: right; padding: 20px;">
        <el-button @click="dialogFormzhixing=false">取消</el-button>
        <el-button type="primary" @click="zhixingformsubmit" :loading="zhixingloading">确认执行</el-button>
      </div>

    </el-dialog>

    <el-dialog :title="nodetitle" :visible.sync="dialogFormnodeinfo" :close-on-click-modal="false" append-to-body width="80%" top="5vh">
      <div>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本信息</span>
            <el-button v-if="!jibeninfobianji" icon="el-icon-edit" size="mini" type="primary" style="margin-left:50px" @click="jibeninfobianji=!jibeninfobianji">编辑</el-button>
            <el-button v-if="jibeninfobianji" icon="el-icon-circle-check" size="mini" type="success" style="margin-left:50px" @click="submitjobinfobtn">保存</el-button>
            <el-button v-if="jibeninfobianji" icon="el-icon-back" size="mini" style="margin-left:10px" @click="getnodeinfo">取消</el-button>
            <i :class="isOpeninfo? 'el-icon-caret-top' :'el-icon-caret-bottom'" style="float:right; cursor: pointer;" @click="isOpeninfo = !isOpeninfo"></i>
          </div>
          <div class="info-box" v-if="isOpeninfo">
            <div class="item">
              <span>job_id：</span>
              <span>{{nodeinfoData.jobId}}</span>
            </div>
            <div class="item">
              <span>job_name：</span>
              <span>{{nodeinfoData.jobName}}</span>
            </div>
            <div class="item">
              <span>描述：</span>
              <span>{{nodeinfoData.jobDesc}}</span>
            </div>
            <div class="item">
              <span>依赖：</span>
              <span>{{nodeinfoData.dependencyJobId}}</span>
            </div>
            <div class="item">
              <span>执行引擎：</span>
              <span>{{nodeinfoData.executionEngine}}</span>
            </div>
            <div class="item">
              <span>监控状态：</span>
              <el-switch v-model="nodeinfoData.isMonitor" size="mini" active-color="#13ce66" inactive-color="#ff4949" :disabled="!jibeninfobianji"></el-switch>
            </div>
            <div class="item">
              <span>调度策略：</span>
              <span v-if="!jibeninfobianji">{{nodeinfoData.jobCronRule}}</span>
              <el-input v-if="jibeninfobianji" size="mini" v-model="nodeinfoData.jobCronRule" style="width:70%;float:left"></el-input>
            </div>
            <div class="item">
              <span>规则：</span>
              <span v-if="!jibeninfobianji">{{nodeinfoData.ruleIds}}</span>
              <el-input v-if="jibeninfobianji" size="mini" v-model="nodeinfoData.ruleIds" style="width:80%;float:left"></el-input>
            </div>
            <div class="item" style="width:100%">
              <span style="float:left">运行参数：</span>
              <span v-if="!jibeninfobianji" style="word-break:normal; width:90%; display:block;white-space:pre-wrap;word-wrap : break-word ;overflow: hidden ;">{{nodeinfoData.operateParam}}</span>
              <el-input v-if="jibeninfobianji" size="mini" v-model="nodeinfoData.operateParam" type="textarea" style="width:90%;float:left"></el-input>
            </div>

          </div>
        </el-card>

        <!-- 表格 -->
        <el-card class="box-card" style="margin-top:20px">
          <div slot="header" class="clearfix">
            <span>字段信息</span>

            <!-- 搜索 -->
            <el-input placeholder="请输入内容" size="small" v-model="search" clearable style="width:200px; margin-left: 50px"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>

            <div class="filterTableHeader" style="float:right;">
              <el-popover width="400" trigger="click">
                <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                  <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
                </el-checkbox-group>
              </el-popover>
            </div>
          </div>

          <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" size='mini' border v-loading="listLoading" :data="tableList" style="width: 100%;" stripe>
            <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" min-width="130px" show-overflow-tooltip>
              <template slot-scope="scope">
                <!-- <el-switch v-model="scope.row[Object.keys(item)[0]]" size="mini" active-color="#13ce66" inactive-color="#ff4949" @change="handleSwitch($event, scope.row)" v-if="Object.keys(item)[0] == 'isRead'"></el-switch> -->
                <span> {{ scope.row[Object.keys(item)[0]]}}</span>
              </template>

            </el-table-column>

            <el-table-column label="操作" width="80px" class-name="small-padding fixed-width" fixed="right">
              <template slot-scope="scope">
                <el-popover placement="right" width="600" trigger="click" popper-class='bianjiinfo'>

                  <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                      <span style="line-height: 30px;font-size: 18px;">{{ruledatainfo.ruleId}}</span>
                      <el-button icon="el-icon-circle-check" size="mini" type="success" style="margin-left:50px;float:right" @click="submitruleinfobtn">保存</el-button>
                    </div>
                    <el-scrollbar ref="scroll" wrap-class="scrollbar-wrapper" :style="{'height':infoheight+'px'}" style="overflow-x: hidden !important;">
                      <el-form label-position="right" label-width="100px" :model="ruledatainfo">
                        <el-form-item label="select字段">
                          <el-input v-model="ruledatainfo.fields" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item label="数据源">
                          <el-input v-model="ruledatainfo.sourceId"></el-input>
                        </el-form-item>
                        <el-form-item label="上级规则">
                          <el-input v-model="ruledatainfo.fromRuleId"></el-input>
                        </el-form-item>
                        <el-form-item label="关联规则">
                          <el-input v-model="ruledatainfo.combineRuleId"></el-input>
                        </el-form-item>
                        <el-form-item label="where条件">
                          <el-input v-model="ruledatainfo.conditions" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item label="节点类型">
                          <el-input v-model="ruledatainfo.executeType"></el-input>
                        </el-form-item>
                        <el-form-item label="inputTable">
                          <el-input v-model="ruledatainfo.inputTableId"></el-input>
                        </el-form-item>
                        <el-form-item label="视图名称">
                          <el-input v-model="ruledatainfo.tmpView"></el-input>
                        </el-form-item>
                        <el-form-item label="outputTable">
                          <el-input v-model="ruledatainfo.outputTableId"></el-input>
                        </el-form-item>
                        <el-form-item label="分区字段">
                          <el-input v-model="ruledatainfo.partitionColumns"></el-input>
                        </el-form-item>
                        <el-form-item label="写出模式">
                          <el-input v-model="ruledatainfo.outputMode"></el-input>
                        </el-form-item>
                        <el-form-item label="中间表">
                          <el-input v-model="ruledatainfo.tableCode"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-scrollbar>
                  </el-card>

                  <el-button slot="reference" size="mini" style="padding: 4px 15px;" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                </el-popover>

              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-dialog>

    <!-- 返回内容全内容展示 并且可以复制 -->
    <el-dialog class="dialog-box" v-if="infoDialog" title="返回内容" :close-on-click-modal="false" :visible.sync="infoDialog" append-to-body width="1200px" top="5vh">
      <div class="wrapper">
        <json-editor ref="jsonEditor" style="font-size:18px" v-model="jsontext" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { azkabanJobFlowId, azkabanRelaod, azkabanexec, azkabanjobinfo, azkabanupdatejob, azkabanupdaterule, azkabanremoveschedule, azkaban_address } from '@Sys~/api/sys'
import InputCron from '@/components/CronElement/common/input-cron'
import Dagre from './dagreProject.vue'
import JsonEditor from '@/components/JsonEditor'

const defaultFormThead = [
  { ruleId: '规则ID' },
  { description: '描述' },
  { fields: 'fields' },
  { sourceId: 'sourceId' },
  { fromRuleId: 'fromRuleId' },
  { combineRuleId: 'combineRuleId' },
  { conditions: 'conditions' },
  { executeType: 'executeType' },
  { nodeType: 'nodeType' },
  { inputTableId: 'inputTableId' },
  { outputTableId: 'outputTableId' },
  { partitionColumns: 'partitionColumns' },
  { outputMode: 'outputMode' },
  { tableCode: 'tableCode' },
  { tmpView: 'tmpView' },
]
const defaultFormThead1 = [
  { ip: 'ip' },
  { name: 'name' },
  { scheduleId: '调度id' },
  { firstSchedTime: '首次执行时间' },
  { nextExecTime: '下次执行时间' },
  { cronExpression: 'cron' },
  { executionOptions: '执行配置' }
]

export default {
  components: { Dagre, InputCron, JsonEditor },
  data() {
    return {
      infoheight: document.body.clientHeight - 190,
      nodeid: "",
      nodetitle: "",
      dialogFormnodeinfo: false,


      isOpeninfo: true,
      tableData: [],
      search: "",
      listLoading: false,
      jibeninfobianji: false,
      tableTheadOptions: defaultFormThead,
      tableTheads: defaultFormThead,
      checkboxTitle: defaultFormThead,

      tableData1: [],
      search1: "",
      tableTheadOptions1: defaultFormThead1,
      tableTheads1: defaultFormThead1,
      checkboxTitle1: defaultFormThead1,

      nodeinfoData: {
        commandType: "",
        dependencyJobId: "",
        executionEngine: "",
        flowId: "",
        isMonitor: true,
        jobCronRule: "",
        jobDesc: "",
        jobEventCode: "",
        jobId: "",
        jobName: "",
        jobState: 1,
        operateParam: "",
        operateType: "",
      },


      shuaxinloading: false,
      zhixingloading: false,

      dialogFormzhixing: false,
      cron: '* * * * * ? *',
      address:[],
      addressOptions:[],
      paramslist: [{
        label: "",
        value: "",
      }],
      paramsinfo: {
        label: "",
        value: "",
      },

      infoData: {
        appkeys: "",//
        crontabRule: "",//
        flowId: "",//
        flowName: "",//
        flowState: "",//
        isMonitor: true,//
        projectId: "",//
        relation: {},
        scheduleMode: ""//
      },

      dialogForm: false,
      dialogTitle: "",

      //基本信息是否展示
      isOpen: true,
      isOpen1: true,
      isRelaOpentable: true,
      isRelaOpen: true, // 关系信息是否展示

      // 图示
      graphData: {},

      ruledatainfo: {
        ruleId: "",// int 规则标识，必传
        fields: "",// String select字段，必传
        sourceId: "",// String 数据源，必传
        fromRuleId: "",// String  上级规则 ，必传
        combineRuleId: "",// String   关联规则，必传
        conditions: "",// String   where条件，必传
        executeType: "",// String   节点类型，必传
        inputTableId: "",//  String  inputTable，必传
        tmpView: "",//  String  视图名称，必传
        outputTableId: "",// String   outputTable，必传
        partitionColumns: "",// String   分区字段，必传
        outputMode: "",// String   写出模式，必传
        tableCode: "",// String   中间表，必传
      },

      jsontext: null,
      infoDialog: false
    }
  },

  filters: {
    // 更新方式
    updateTypeFilter(type) {
      if (type == 1) {
        return "开启"
      } else {
        return "关闭"
      }
    },
    neirongsuojian(value) {
      if (value == null) {
        return "";
      } else {
        return JSON.stringify(value).substring(0, 25) + "...";
      }

    },
  },

  watch: {
    // 筛选表名
    checkboxTitle(valArr) {
      // console.log(valArr)
      this.tableTheads = this.tableTheadOptions.filter(i => valArr.indexOf(i) >= 0)
      // console.log(this.tableTheads)
      this.key = this.key + 1
    },

    checkboxTitle1(valArr) {
      // console.log(valArr)
      this.tableTheads1 = this.tableTheadOptions1.filter(i => valArr.indexOf(i) >= 0)
      // console.log(this.tableTheads)
      this.key = this.key + 1
    }
  },

  computed: {
    // 模糊搜索 表格
    tableList() {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search) > -1
          })
        })
      } else {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return data
          })
        })
      }
      return this.tableData
    },

    tableList1() {
      const search = this.search1
      if (search) {
        return this.tableData1.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search) > -1
          })
        })
      } else {
        return this.tableData1.filter(data => {
          return Object.keys(data).some(key => {
            return data
          })
        })
      }
      return this.tableData1
    },
  },

  created() {
    // this.getnodeinfo()
  },

  methods: {
    getnodetitle(data) {
      this.nodetitle = data.data.label;
      this.nodeid = data.data.id;
      this.dialogFormnodeinfo = true;
      this.getnodeinfo()
    },

    getnodeinfo() {
      azkabanjobinfo(this.nodeid).then(response => {
        if (response.code == 1) {
          // 基本信息
          // console.log(response.data)
          this.nodeinfoData = response.data;
          if(!response.data.rules){
            this.tableData = []
          }else{
            this.tableData = response.data.rules
          }
          
        }
        this.jibeninfobianji = false;
      })
    },
    submitjobinfobtn() {
      azkabanupdatejob(
        {
          jobId: this.nodeinfoData.jobId,//  String jobId必传
          ruleIds: this.nodeinfoData.ruleIds,// String 规则，必传
          operateParam: this.nodeinfoData.operateParam,//  String 运行参数，必传
          jobCronRule: this.nodeinfoData.jobCronRule,//  String  调度策略，必传
          isMonitor: this.nodeinfoData.isMonitor,//  boolean  监控状态，必传
        }
      ).then(response => {
        if (response.code == 1) {
          this.getnodeinfo();
          this.$message.success(response.msg);
        }
      })
    },
    // 获取详情
    getList(id) {
      azkabanJobFlowId(id).then(response => {
        if (response.code == 1) {
          // 基本信息
          this.infoData = {
            appkeys: response.data.appkeys,
            crontabRule: response.data.crontabRule,
            flowId: response.data.flowId,
            flowName: response.data.flowName,
            flowState: response.data.flowState,
            isMonitor: response.data.isMonitor,
            projectId: response.data.projectId,
            scheduleMode: response.data.scheduleMode,
          }
          this.tableData1 = response.data.schedule
          this.graphData = response.data.relation
        }
      })
    },

    shuaxinbtn() {
      this.shuaxinloading = true;
      azkabanRelaod(this.infoData.projectId).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg);
        }
        this.shuaxinloading = false;
      })
    },
    zhixingbtn() {
      this.dialogFormzhixing = true;
      this.cron = this.infoData.crontabRule;
      this.address = []
      this.paramslist = [{
        label: "",
        value: "",
      }];
      this.$nextTick(() => {
        this.getAzkaban_address() // 调度资源
      })
    },
    addcanshu() {
      this.paramslist.push(JSON.parse(JSON.stringify(this.paramsinfo)))
    },
    deletecanshu(e, i) {
      this.paramslist.splice(i, 1)
    },
    zhixingformsubmit() {
      var params = {};
      for (var i = 0; i < this.paramslist.length; i++) {
        if (this.paramslist[i].label == "" || this.paramslist[i].value == "") {
          this.$message.warning("请完善或删除填写不完整的参数条目！");
          return false
        }
        params[this.paramslist[i].label] = this.paramslist[i].value
      }
      this.zhixingloading = true;
      azkabanexec(
        {
          projectId: this.infoData.projectId,// String  项目id
          flowId: this.infoData.flowId,//     String  flowId
          cron: this.cron,//       String  调度规则，可以为空，为空则为立即执行，不为空则为定时执行，格式是cron表达式
          params: params,//     Object 拓展参数
          address: this.address
        }
      ).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg);
        }
        this.zhixingloading = false;
        this.dialogFormzhixing = false;
      })
    },
    handleEdit(row) {
      console.log(row)
      this.ruledatainfo = {
        ruleId: row.ruleId,// int 规则标识，必传
        fields: row.fields,// String select字段，必传
        sourceId: row.sourceId,// String 数据源，必传
        fromRuleId: row.fromRuleId,// String  上级规则 ，必传
        combineRuleId: row.combineRuleId,// String   关联规则，必传
        conditions: row.conditions,// String   where条件，必传
        executeType: row.executeType,// String   节点类型，必传
        inputTableId: row.inputTableId,//  String  inputTable，必传
        tmpView: row.tmpView,//  String  视图名称，必传
        outputTableId: row.outputTableId,// String   outputTable，必传
        partitionColumns: row.partitionColumns,// String   分区字段，必传
        outputMode: row.outputMode,// String   写出模式，必传
        tableCode: row.tableCode,// String   中间表，必传
      }
    },
    submitruleinfobtn() {
      azkabanupdaterule(this.ruledatainfo).then(response => {
        if (response.code == 1) {
          this.getnodeinfo();
          this.$message.success(response.msg);
        }
      })
    },
    // 返回内容详情
    jinruyouxi(row) {
      this.infoDialog = true
      this.jsontext = row
    },
    handleDelete(row) {
      console.log(row)
      azkabanremoveschedule({ scheduleId: row.scheduleId, ip: row.ip }).then(response => {
        if (response.code == 1) {
          this.getList(this.infoData.flowId);
          this.$message.success(response.msg);
        }
      })
    },

    // 调度资源
    getAzkaban_address() {
      azkaban_address().then(response => {
        if(response.code == 1) {
          this.addressOptions = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 10px;
}
.box-card {
  width: 100%;
  ::v-deep .el-card__header {
    padding: 10px 12px !important;
  }
  ::v-deep .el-card__body {
    padding: 10px !important;
  }
}
.info-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding: 10px 10px 0;
  .item {
    font-size: 14px;
    color: #666;
    min-width: 30%;
    margin-right: 15px;
    margin-bottom: 8px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    .label {
      width: 50px;
    }
    .tag {
      margin: 5px 5px;
    }
  }
  .all {
    min-width: 100%;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
.bianjiinfo {
  padding: 0px !important;
}
// ::v-deep .el-form-item--medium .el-form-item__label{
//   line-height: 28px;
// }
::v-deep .el-form-item{
  margin-bottom: 5px;
}
.select-box{
  ::v-deep .el-select__tags{
      .el-tag {
          max-width: 74%;
          overflow: hidden;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;
          .el-select__tags-text{
              width: 100%;
              overflow: hidden;
          }
      }
      .el-select__input{
          margin-left: 2px;
      }
  }
  ::v-deep .el-select-dropdown__item{
    padding: 0 20px 0 10px;
  }
  ::v-deep.el-select-dropdown__item.selected::after{
    right: 5px;
  }
}
</style>